<template lang="pug">
  app-modal(v-model="visible" :title="title" :width="500" :confirm-loading="loading" @ok="handleSubmit" @cancel="hide")
    app-form(:model="model" :rules="rules" ref="form" oneline :labelWidth="90")
      
      a-form-model-item(label="产品名称" prop="name" )
        a-input(v-model="model.name" allow-clear :max-length="30" placeholder="请输入产品名称")
      a-form-model-item(label="产品类别" prop="categoryId" )
        app-tree-select(v-model="model.categoryId" api="/prj/categories/all-graph" treeDefaultExpandAll :params="params" allow-clear placeholder="请选择产品类别")
      
      a-form-model-item(label="产品品牌" prop="brandId" )
        app-remote-select(v-model="model.brandId"  api="/prj/brands/list" :params="params" allow-clear placeholder="请选择产品品牌" showSearch)
      a-form-model-item(label="分件数(件)" prop="parts" )
        a-input-number(v-model="model.parts" allow-clear :min="1" placeholder="请输入产品分件数")
        
      a-form-model-item(label="产品型号" prop="model" )
        a-input(v-model="model.model" allow-clear :max-length="30" placeholder="请输入产品型号")
      a-form-model-item(label="产品规格" prop="specification" )
        a-input(v-model="model.specification" allow-clear :max-length="30" placeholder="请输入产品名称")

      a-form-model-item(label="是否启用" prop="enabled" )
        a-switch(v-model="model.enabled")
      a-form-model-item(label="是否安装" prop="needInstall" )
        a-switch(v-model="model.needInstall")
      //- a-form-model-item(label="服务费(￥)" prop="serviceFee" )
      //-   a-input-number(v-model="model.serviceFee" allow-clear :min="0" placeholder="请输入" prefix="￥" suffix="RMB")
      //- a-form-model-item(label="配送费(￥)" prop="deliveryFee" )
      //-   a-input-number(v-model="model.deliveryFee" allow-clear :min="0" placeholder="请输入" prefix="￥" suffix="RMB")
      //- a-form-model-item(label="记件费(￥)" prop="pieceFee" )
      //-   a-input-number(v-model="model.pieceFee" allow-clear :min="0" placeholder="请输入" prefix="￥" suffix="RMB")


      a-form-model-item(label="备注" prop="comments" )
        a-textarea(v-model="model.comments" allow-clear :max-length="30" placeholder="请输入")
        
            
        
</template>

<script>
import { GETTER_PROJECT, GETTER_USER } from '@store/account';
import { mapGetters } from 'vuex';
// import InspItemCreateAndEdit from './InspItemCreateAndEdit';
export default {
  name: 'CreateAndEdit',
  components: {
    // InspItemCreateAndEdit,
  },
  data() {
    return {
      visible: false,
      loading: false,
      title: '添加产品',
      model: {
        name: null,
        categoryId: null,
        brandId: null,
        model: null,
        specification: null,
        parts: 1,
        enabled: true,
        comments: null,
        serviceFee: null,
        deliveryFee: null,
        pieceFee: null,
        needInstall: false,
      },
      rules: {
        name: [{ required: true, message: '必填项' }],
      },
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
      user: GETTER_USER,
    }),
    params() {
      return {
        projectId: this.project.id,
      };
    },
  },
  mounted() {},
  methods: {
    show(model, action) {
      // this.$refs.form.resetFields();
      this.model = {
        ...this.model,
        ...model,
      };
      this.action = action;
      this.title = model === undefined ? '添加产品' : '编辑产品';
      this.visible = true;
    },
    hide() {
      this.visible = false;
      this.$refs.form.resetFields();
      this.model = {
        name: null,
        categoryId: null,
        brandId: null,
        model: null,
        specification: null,
        parts: 1,
        enabled: true,
        comments: null,
        serviceFee: null,
        deliveryFee: null,
        pieceFee: null,
        needInstall: false,
      };
      // this.$refs.item.handleCancel();
    },
    async handleSubmit() {
      const valid = await this.$refs.form.validate();
      if (valid) {
        this.loading = true;
        this.$restful(`save:/prj/products`, {
          ...this.model,
          projectId: this.project.id,
        })
          .then(() => {
            this.$message.success(this.title + '成功!');
            this.$emit('modal-success');
            this.hide();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    handleInspTypeChange() {
      this.model.targetKeys = null;
    },
    handleDleteItem(itemId) {
      this.model.rmItemIds.push(itemId);
    },
    handleClickAddItem() {
      this.$refs.form.clearValidate(['itemDTOS']);
    },
  },
};
</script>

<style lang="less" scoped>
.checkbox-item {
  padding-left: 90px;
  margin: -10px 0 16px 0;
}
.insp-item-list {
}
</style>
